import React, { useEffect, useRef, useState } from 'react';

function Fade({
  children,
  bottom,
  left,
  right,
  delay = 0,
  duration = 700,
  cascade,
}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const getInitialTransform = () => {
    if (left) return 'translateX(-28px)';
    if (right) return 'translateX(28px)';
    if (bottom) return 'translateY(28px)';
    return 'translateY(0)';
  };

  return (
    <div
      ref={ref}
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'none' : getInitialTransform(),
        transition: `opacity ${duration}ms ease, transform ${duration}ms ease`,
        transitionDelay: `${delay}ms`,
      }}
    >
      {cascade ? children : children}
    </div>
  );
}

export default Fade;
